import { useCallback } from 'react';
import { FileRouteTypes, Link } from '@tanstack/react-router';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { HStack, Text, VStack } from 'ui_2';
import { AccountAndBalance } from '../AccountAndBalance';
import { Route as index_route } from '@routes/index';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { ProductSKU } from 'jigsaw';
import puzzleIcon from '../../../public/assets/icon-34.png';
import { Route as product_sku_route } from '@routes/$service/$productSKU/index';
import { Route as service_index_route } from '@routes/$service/index';
import { useViewTransition } from '@src/hooks/useViewTransition';

type Props = {
  productSKU: ProductSKU;
  backRoute?: FileRouteTypes['to'];
  onBack?: () => void;
};
const headerXPadding = `px-4 sm:px-8 md:px-16`;
const headerYPadding = `py-4 md:py-8`;

export const ProductPageHeader = ({ productSKU, backRoute, onBack }: Props) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();
  const { slideRightFullPage } = useViewTransition();

  const BackButton = useCallback(() => {
    if (backRoute) {
      return (
        <Link
          to={backRoute}
          onClick={onBack}
          viewTransition={slideRightFullPage}
          className='-translate-x-[7.5px]'
        >
          <BiChevronLeft size={24} className={'text-black'} />
        </Link>
      );
    }
  }, [backRoute, onBack, slideRightFullPage]);

  return (
    <VStack className='sticky top-0 z-50 w-full gap-4 bg-white text-left'>
      <HStack
        className={`w-full items-center gap-2 border-b border-gray-200 ${headerXPadding} ${headerYPadding}`}
      >
        {isPuzzleWalletWebview === false && (
          <>
            <Link to={index_route.to}>
              <img
                src={puzzleIcon}
                className='h-[42px] w-[42px] object-contain'
                alt='Puzzle Wallet Logo'
              />
            </Link>
            <Text font='bold-xl' className='hidden lg:block'>
              Puzzle Arcade Store
            </Text>
            <Text
              font='bold-md'
              className='max-lg:hidden hidden sm:block lg:hidden'
            >
              Arcade Store
            </Text>
          </>
        )}
        {isPuzzleWalletWebview === true && <BackButton />}
        <HStack className='flex-grow' />
        <AccountAndBalance />
      </HStack>
      {isPuzzleWalletWebview === false && (
        <HStack
          className={`hidden items-center gap-1 md:flex ${headerXPadding}`}
        >
          <Link to={'/'}>
            <Text font='medium-md' className='cursor-pointer hover:underline'>
              Services
            </Text>
          </Link>
          <BiChevronRight />
          <Link
            to={service_index_route.to}
            from={product_sku_route.fullPath}
            onClick={onBack}
          >
            <Text font='medium-md' className='cursor-pointer hover:underline'>
              {productSKU.service.title}
            </Text>
          </Link>
        </HStack>
      )}
    </VStack>
  );
};
